import React, { useState, useEffect} from "react";
import {Card, Col, Container, Row,ListGroup, Table} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {getRideForDriver} from "../contexts/RidesContext";
import './design.css'


export default function RidePageDriver() {
    const [ride, setRide] = useState({})
    const { id } = useParams()

    useEffect(()=>{
        const fetchRide = async () => {
          const ride = await getRideForDriver(id)
          setRide(ride)
        }
        fetchRide().catch(console.error);
      }, [ride]);

    return(
        <>
            <Card className="text-center" style={{ width: '40rem' }}>
                
                    <ListGroup variant="flush">
                        <ListGroup.Item>
                            <Container>
                                <Row>
                                    <Col><u>Passengers to pick up</u></Col>
                                </Row>
                                <div style={{height:50}}></div>
                                <Row>
                                    <Col>
                                        <Table striped hover size="sm">
                                            <thead>
                                                <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Phone Number</th>
                                                <th>Address</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                ride['riders_data'] && ride['riders_data'].map((pasenger, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{pasenger['full_name']}</td>
                                                            <td>{pasenger['phone_number']}</td>
                                                            <td>{pasenger['address']}</td>
                                                        </tr>
                                                    )})
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <div style={{height:50}}></div>
                                <Row>
                                    <Col><b>{ ride['time'] }</b></Col>
                                </Row>
                                <Row>
                                    <Col><b>{ ride['course_name'] }</b></Col>
                                </Row>
                            </Container>
                        </ListGroup.Item>
                        <ListGroup.Item>
                        <iframe width="600px" height="400px" srcDoc={ride['map']} title='rideMapHtml'></iframe>
                        </ListGroup.Item>
                    </ListGroup>
                <Card.Body>
                </Card.Body>
            </Card>
            <div className="w-100 text-center mt-2">
                <Link to="/">Back</Link>
            </div>
        </>
    )
}